<script setup lang="ts">
import { CategoryPills } from '~/components/ui/category-pills'
import type { IInsuranceTypes } from '~/components/widget/select-insurance-type/types'
import type { IResponseData } from '~/types'

// Same request and key as WidgetSelectInsuranceType, so the pills mirror the sidebar menu
// and the request is shared with it
const url = useUrlWithParams('/insurance_types', { 'filter[position]': 'sidebar' })
const { data: insuranceTypesData } = await useApi<IResponseData<IInsuranceTypes[]>>(() => url, {
  key: 'insurance-types-sidebar-widget'
})

const items = computed(
  () =>
    insuranceTypesData.value?.data.map((type) => ({
      title: type.title,
      url: `/insurances/${type.slug}`,
      icon: type.slug
    })) ?? []
)
</script>

<template>
  <CategoryPills :items="items" :sheet-title="$t('widget.select_insurance_type.heading')" />
</template>
